import { useEffect, useState } from "react";
import CIcon from "@coreui/icons-react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";

import { Role } from "utils";
import { getUtcFormattedDate } from "utils/dates";
import { IconButton, Table } from "components";
import EditSubscriptionsModal from "pages/Carehomes/UI/components/EditSubscriptionsModal";

const UserSubscriptions = ({ user }) => {
  const [subscriptionsModal, setSubscriptionsModal] = useState(false);

  const [subscriptionToEdit, setSubscriptionToEdit] = useState(null);
  useEffect(() => {
    setSubscriptionToEdit(null);
  }, [user]);

  // Table data
  const fields = [
    "status",
    "thrivers",
    "linkedThrivers",
    "start",
    {
      key: "currentPeriodStart",
      label: "Current period start",
      _style: {
        minWidth: "120px",
        paddingLeft: "15px",
      },
    },
    {
      key: "currentPeriodEnd",
      label: "Current period end",
      _style: {
        minWidth: "120px",
        paddingLeft: "15px",
      },
    },
  ];
  if (user?.type === "carehome" && Role.adminAccess()) fields.unshift("edit");

  const hideSubscriptions = (user?.subscriptions?.length || 0) === 0;

  return hideSubscriptions ? (
    <IconButton name="No subscriptions" icon="cil-wallet" disabled />
  ) : (
    <span>
      <IconButton
        icon="cil-wallet"
        name={`${user.type === "carehome" ? "Edit" : "See"} subscriptions`}
        onClick={() => setSubscriptionsModal(true)}
      />

      <CModal
        show={subscriptionsModal}
        onClose={() => setSubscriptionsModal(false)}
        style={{ opacity: subscriptionToEdit ? 0 : 1 }}
        size="xl"
      >
        <CModalHeader closeButton>
          <CModalTitle>Subscriptions of {user?.name}</CModalTitle>
        </CModalHeader>
        <CModalBody className="p-3">
          <Table
            hover={false}
            data={user?.subscriptions || []}
            label="Subscriptions"
            fields={fields}
            columnFilter={false}
            columnDefinitions={{
              start: (subscription) => (
                <td>{getUtcFormattedDate(subscription.start)}</td>
              ),
              currentPeriodStart: (item) => (
                <td style={{ paddingLeft: "15px" }}>
                  {getUtcFormattedDate(item.currentPeriodStart)}
                </td>
              ),
              currentPeriodEnd: (subscription) => (
                <td style={{ paddingLeft: "15px" }}>
                  {getUtcFormattedDate(subscription.currentPeriodEnd)}
                </td>
              ),
              edit: (subscription) => (
                <td>
                  <CButton
                    onClick={() => setSubscriptionToEdit(subscription)}
                    className="hover-blue"
                    color="secondary"
                    size="sm"
                  >
                    <CIcon name="cil-pencil" />
                  </CButton>
                </td>
              ),
            }}
          />
        </CModalBody>
      </CModal>

      <EditSubscriptionsModal
        subscription={subscriptionToEdit}
        show={Boolean(subscriptionToEdit)}
        onClose={() => setSubscriptionToEdit(null)}
        userId={user.identifier}
      />
    </span>
  );
};

export default UserSubscriptions;
